
















































import { Vue, Component, Prop } from "vue-property-decorator";
import { LectureSlide as ILectureSlide } from "@/api/models/lecture-slide";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";

@Component
export default class SlideView extends Vue {
  @Prop() slides?: Array<ILectureSlide>;
  @Prop({ default: false }) isLecture?: boolean;
  currentSlide!: ILectureSlide | undefined;
  currentIndex: number = 0;

  data() {
    return {
      currentSlide: undefined
    };
  }

  getCurrentSlide(index: number = 0) {
    this.currentIndex = index;
    this.currentSlide = undefined;
    if (this.slides) {
      this.getMethodByProp(index)
        .then((res: { data: ILectureSlide }) => {
          this.currentSlide = res.data;
          this.$emit("scrollToUp");
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  get checkBodyToFileName() {
    return this.currentSlide?.images?.find(el => {
      return this.currentSlide?.body === el.name;
    });
  }

  getMethodByProp(index: number) {
    let method: any;

    if (this.isLecture && this.slides?.length)
      method = api.LectureSlideApi.get(
        this.$route.params.id,
        this.slides[index].id
      );

    if (!this.isLecture && this.slides?.length)
      method = api.CourseLectureApi.getSlide(
        this.$route.params.courseId,
        this.$route.params.courseLectureId,
        this.slides[index].id
      );

    return method;
  }

  beforeMount() {
    document.addEventListener("keyup", this.handleKeydown);
  }
  beforeDestroy() {
    document.removeEventListener("keyup", this.handleKeydown);
  }

  handleKeydown(e: any) {
    if (e.code === "ArrowRight") {
      if (this.slides && this.currentIndex < this.slides.length - 1) {
        this.getCurrentSlide(this.currentIndex + 1);
      }
    }
    if (e.code === "ArrowLeft") {
      if (this.currentIndex !== 0) {
        this.getCurrentSlide(this.currentIndex - 1);
      }
    }
  }

  created() {
    this.getCurrentSlide();
  }
}
